import { render, staticRenderFns } from "./ProductcenterGaiAView.vue?vue&type=template&id=61e1070b&scoped=true"
import script from "./ProductcenterGaiAView.vue?vue&type=script&lang=js"
export * from "./ProductcenterGaiAView.vue?vue&type=script&lang=js"
import style0 from "./ProductcenterGaiAView.vue?vue&type=style&index=0&id=61e1070b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e1070b",
  null
  
)

export default component.exports